var SSSJs = function () {

    return {
        //main function to initiate the module
        init: function () {
            $('#SSSDesc .panel').off('show.bs.collapse').on('show.bs.collapse', function (e) {
                $(this).addClass('acik');
            });

            $('#SSSDesc .panel').off('hide.bs.collapse').on('hide.bs.collapse', function (e) {
                $(this).removeClass('acik');
            });
        }
    };

}();

function collapseOpen() {
    var vars = [], hash;
    var collapse = "";
    var newScrollTop = 0;
    var NativeQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1); // QueryString okunur
    var getQueryFilter = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&'); // QueryString okunur ve Split eder

    if (NativeQueryFilter.indexOf("=") != "-1") {
        for (var i = 0; i < getQueryFilter.length; i++) {
            hash = getQueryFilter[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];

            if (hash[0] == "open") {
                collapse = hash[1]; // collapse değerleri alınır
            }
        }
    }
    if (collapse != null && collapse != undefined && collapse != "") {
        if ($("#" + collapse).length > 0) {
            $("#" + collapse).collapse("show");
            newScrollTop = $("#" + collapse).offset().top;
            $('html, body').animate({
                scrollTop: newScrollTop
            }, 0);
        }      
    }  
}

$(document).ready(function () {
    var cName = $("#CName").val();
    //$('.catalogSliderList').slick({
    //    infinite: true,
    //    autoplay: true,
    //    autoplaySpeed: 3000,
    //    dots: true
    //}),

    //$('.ZeroCatList').slick({
    //    infinite: true,
    //    autoplay: true,
    //    autoplaySpeed: 3000,
    //    dots: true
    //}),

    $('.fancybox-media').fancybox({
        openEffect: 'none',
        closeEffect: 'none',
        helpers: {
            media: {}
        }
    }),

        SSSJs.init();
    if (window.location.hash) {
        $(".YurtdisiIade").trigger("click");
    }
    
    if (cName != null && cName != undefined && cName == "ContentPg") {
        collapseOpen();
    }    

    //$(".contentTopMenuList li a").live("click", function () {
    //    collapseOpen();
    //});
});